import request from '@/utils/request'

export function select_show(id) {
  return request.get('games/selectGameShow.json?id=' + id)
}

export function select_games() {
  return request.get('games/selectGames.json')
}
